import React from 'react'
import { testimonialsData } from '../../../utils/constants'
import {Badge, ServiceCard, SubHeader} from '../..'

import './testimonials.css'

const Testimonials = () => {
  const [stopScroll, setStopScroll] = React.useState(false);

  return (
    <>
      <div id='testimonials' className='testimonials-wrapper'>
        <Badge title="Testimonials" />
        <SubHeader title="What Our Residents and Families Say." description="Our residents and families love Shalom Springs of Plano! Here are a few of their stories." />
        <div className='testimonials-container'>
          <div className="testimonials-box-container" onMouseEnter={() => setStopScroll(true)} onMouseLeave={() => setStopScroll(false)}>
            <div className="testimonials-background-top"></div>
            <div className="testimonials-box-details marquee-inner"  style={{ animationPlayState: stopScroll ? "paused" : "running", animationDuration: testimonialsData.length * 2500 + "ms" }}>
              {testimonialsData.map((result, index) => (
                <ServiceCard key={index} result={result} index={index} />
              ))}
            </div>
            <div className="testimonials-background-bottom"></div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Testimonials